<div class="alert alert-danger" role="alert" *ngIf="isError" style="width: 100%;">
    <div *ngFor="let error of validationErrors">
        <p>{{error}}</p>
    </div>
</div>
<!-- <div *ngIf="!isError" style="display: flex; flex-direction: row;"> -->
<div style="height: calc(100% - 50px); display: flex; flex-direction: row; gap: 2em;">
    <div [formGroup]="contact_form" class="row" style="width: 40%; height: 50%;">
        <h5>{{agencyName}}</h5>
        <mat-form-field>
            <mat-label>Full Name</mat-label>
            <input matInput formControlName="fullName">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="emailAddress"/>
        </mat-form-field>    

        <mat-form-field>
            <mat-label>Role</mat-label>
            <mat-select required formControlName="role">
                <mat-option *ngFor="let role of roles" [value]="role.value">
                    {{ role.displayName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        
        <mat-form-field>
            <mat-label>Agency</mat-label>
            <mat-select (selectionChange)="getCompanyData($event)" formControlName="agency" required>
                <mat-option *ngFor="let company of companyNames" [value]="company.company_id">
                    {{ company.company_name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Department</mat-label>
            <mat-select formControlName="department" required>
                <mat-option *ngFor="let department of departmentNames" [value]="department.department_id">
                    {{ department.department_name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-checkbox formControlName="tempPassword">Reset Password</mat-checkbox>
        <div style="display: relative;">
            <button mat-raised-button color='primary' style="float: right; width: 15%;" (click)="createAccount()">Submit</button>
        </div>    
    </div>
    
    <div style="width: 60%;">
        <button mat-raised-button color='primary' (click)="emailSelectedRows()">Email List</button>
        <div class="row" style="width: 100%; height: calc(100% - 150px)">
            <app-custom-table class="ag-theme-material" [rowData]="gridApi_contact_data"
                [columnDefs]="columnDefs_contact" [hideGlobalFilter]="true" [animateRows]="true" [pagination]="true"
                [showLoader]="showLoader" [paginationPageSize]="30" (gridReady)="onGridReady($event)"
                >
            </app-custom-table>
        </div>
    </div>
</div>
